/**
 * EPOC (Enfermedad Pulmonar Obstructiva Crónica) Pathology Configuration
 *
 * This file contains the complete configuration for the EPOC pathology.
 * Note: Some components are not yet implemented (marked as null).
 */

export const EPOC_ID = 4;

export const epocConfig = {
  id: EPOC_ID,
  name: "EPOC",
  displayNameKey: "epoc", // i18n translation key

  // Feature flags - determines what features are available for this pathology
  // Available features:
  // surveys, ecg, nutrition, howIFeel, modalities, healthBackground, medicalInformation, configParameters
  // Only include features that are enabled (presence = enabled, absence = disabled)
  features: ["medicalInformation", "glossary", "healthData"],

  components: {
    medicalInfoForm: null, // To be implemented
  },

  dashboard: {
    exportFields: [],
    exportTransformer: null,
  },

  profileFields: {
    weight: true,
    height: true,
    bmi: true,
    bloodPressure: false,
    heartRate: true,
    ejectionFraction: false,
  },

  alerts: {
    showHowIFeelColumn: false,
    priorityLevels: [1, 2, 3],
  },
};

export default epocConfig;
